var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.933594 4.5H11.9336V6.5H0.933594V4.5ZM0.933594 2.5H11.9336V0.5H0.933594V2.5ZM0.933594 10.5H7.93359V8.5H0.933594V10.5ZM15.9436 7.37L16.6536 6.66C17.0436 6.27 17.6736 6.27 18.0636 6.66L18.7736 7.37C19.1636 7.76 19.1636 8.39 18.7736 8.78L18.0636 9.49L15.9436 7.37ZM15.2336 8.08L9.93359 13.38V15.5H12.0536L17.3536 10.2L15.2336 8.08Z",
    fill: "url(#paint0_linear_4537_73)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4537_73",
    x1: 0.933594,
    y1: 0.5,
    x2: 15.6678,
    y2: 18.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032FCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreFilled);
export default __webpack_public_path__ + "static/media/pre-filled.3f8c6d4ec1f7d8c3354406bde86f73a3.svg";
export { ForwardRef as ReactComponent };